import { useState,useEffect } from "react";


const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
    zIndex: 999,
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  navPanel: {
    overflowY: 'scroll',
    transform: 'translateX(100%)',
    top: 0,
    right: 0,
    bottom: 0,
    width: '350px',
    height: '100%',
    position: 'fixed',
    zIndex: 99999,
    backgroundColor: '#fff',
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.5s cubic-bezier(0.77, 0, 0.175, 1)',
  },
  navPanelOpen: {
    transform: 'translateX(0)',
  },
  closeBtn: {
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    color: '#ccc',
    display: 'inline-block',
    textAlign: 'center',
    position: 'absolute',
    right: '25px',
    top: 0,
  },
  closeIcon: {
    fontSize: '2.625rem',
  },
  logoPanel: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '135px',
    backgroundColor: '#EEB85E',
  },
  sidebarNav: {
    overflowX: 'hidden',
    width: '100%',
    position: 'absolute',
    paddingTop: '20px',
    top: '135px',
    bottom: 0,
    left: 0,
    paddingLeft: '20px',
    paddingRight: '10px',
    zIndex: 9999,
    backgroundColor: '#3a4a26',
  },
  navList: {
    listStyle: 'none',
    position: 'absolute',
    top: 0,
    padding: '1rem',
    width: '100%',
    height: '100%',
    background: '#3a4a26',
    transition: 'all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1)',
    zIndex: 1,
  },
  navLink: {
    fontSize: '14px',
    color: '#EEB85E',
    textDecoration: 'none',
    fontWeight: 600,
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: '10px',
    padding: '0.35rem 0.65rem',
    transition: 'all 0.2s',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 99999,
    padding: '0 25px',
    fontSize: '14px',
  },
  phone: {
    padding: '20px 0',
    position: 'relative',
    lineHeight: 1.4,
  },
  phoneLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  phoneIcon: {
    marginRight: '15px',
    fontSize: '1.875rem',
    color: '#EEB85E',
  },
  phoneText: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#EEB85E',
  },
  phoneSub: {
    color: '#EEB85E',
    display: 'block',
    fontStyle: 'inherit',
    textTransform: 'uppercase',
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '2px',
  },
  credit: {
    paddingBottom: '20px',
    color: '#EEB85E',
  },
};


const SideNavigation = ({ isOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
const navPanelStyle = {
  ...styles.navPanel,
  ...(isOpen ? styles.navPanelOpen : {}),
  ...(isMobile ? { width: '100%' } : {}),
};


  return (
    <>
      <div
        style={{
          ...styles.overlay,
          ...(isOpen ? styles.overlayVisible : {}),
        }}
        onClick={onClose}
      />

      <div style={navPanelStyle}>
  <a href="/BananaBunksKandy" style={styles.closeBtn} onClick={onClose}>
    <i className="bi bi-x" style={styles.closeIcon}></i>
  </a>

  <div style={styles.logoPanel}>
    <a href="/BananaBunksKandy">
      <img
        src="/bbkandy/images/logo/logo.png"
        alt="Banana Bunks Kandy Logo"
        style={{ maxHeight: '60px' }}
      />
    </a>
  </div>

        <div style={styles.sidebarNav}>
          <nav>
            <ul style={styles.navList}>
              {[
                ['HOME', '/BananaBunksKandy'],
                ['ROOMS & BUNKS', '/BananaBunksKandy/room'],
                ['EAT & DRINK', '/BananaBunksKandy/dining'],
                ['GALLERY', 'BananaBunksKandy/gallery'],
                ['OFFERS', '/BananaBunksKandy/offers'],
                ['ABOUT US', '/BananaBunksKandy/aboutus'],
                ['CONTACT US', '/BananaBunksKandy/contactus'],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} style={styles.navLink}>
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://app.channelmanager.com.au/booknow/Chain/kent-chain-135"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.navLink}
                >
                  <b>BOOK YOUR STAY</b>
                </a>
              </li>
            </ul>

            <div style={styles.footer}>
              <div style={styles.phone}>
                <a href="tel:+94767008800" style={styles.phoneLink}>
                  <i className="bi bi-telephone" style={styles.phoneIcon}></i>
                  <span>
                    <em style={styles.phoneSub}>Contact Us</em>
                    <span style={styles.phoneText}>+94 76 700 8800</span>
                  </span>
                </a>
              </div>
              <div style={styles.credit}>
                Designed and Developed by{" "}
                <a
                  href="https://ollcode.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#EEB85E' }}
                >
                  <b>Ollcode</b>
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default SideNavigation;
